import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';
import Link from '@cotyorg/ccx-atoms/Link';
import IconLink from '@cotyorg/ccx-molecules/IconLink';

const generateLabelClassNames = ({ skuImage }) => classNames(
  'product-radio__label',
  {
    'product-radio__label--image': skuImage,
  },
  'product-swatch-links__link',
);

const addLinkShadeParam = ({ linkUrl, shade, originUrl }) => {
  const linkWithShade = new URL(linkUrl, originUrl);
  linkWithShade.searchParams.append('shade', shade);

  return linkWithShade.toString();
};

const ProductSwatchColourLinks = ({
  swatches,
  swatchLimit,
  linkUrl,
  moreIconSrc,
  originUrl,
}) => {
  const limitedSwatches = swatchLimit ? R.take(swatchLimit, swatches) : swatches;
  const showMoreIcon = swatchLimit && swatches.length > swatchLimit;

  return Array.isArray(swatches) && (
    <ul className="product-swatch-links">
      {limitedSwatches.map(({
        sku,
        skuColor,
        skuImage,
        itemName: shade,
      }) => (
        <li key={sku}>
          <Link link={addLinkShadeParam({ linkUrl, shade, originUrl })}>
            <span
              className={generateLabelClassNames({ skuImage })}
              style={{
                backgroundColor: skuColor,
                ...(skuImage && { backgroundImage: `url(${skuImage})` }),
              }}
            />
          </Link>
        </li>
      ))}
      {showMoreIcon && moreIconSrc && (
        <li>
          <IconLink link={linkUrl} extraClass="product-swatch-links__link" iconSrc={moreIconSrc} size="medium" />
        </li>
      )}
    </ul>
  );
};

ProductSwatchColourLinks.propTypes = {
  swatches: PropTypes.arrayOf(PropTypes.shape({
    sku: PropTypes.string.isRequired,
    skuColor: PropTypes.string,
  })).isRequired,
  swatchLimit: PropTypes.number,
  image: PropTypes.string,
  linkUrl: PropTypes.string,
  moreIconSrc: PropTypes.string,
  originUrl: PropTypes.string,
};

export default ProductSwatchColourLinks;
